import React from "react";
export function buildMetaTags(data) {
    if (!data?.mdx?.frontmatter) return [];
  
    const fm = data.mdx.frontmatter;
    const metaTags = [];
  
    const meta_title = fm.meta_title || fm.title;
    metaTags.push(
      <title key="seo-title">{meta_title}</title>,
      <meta key="seo-og-title" property="og:title" content={meta_title} />,
      <meta key="seo-tw-title" property="twitter:title" content={meta_title} />
    );
  
    const meta_description = fm.meta_description || fm.excerpt;
    if (meta_description) {
      metaTags.push(
        <meta key="seo-desc" name="description" content={meta_description} />,
        <meta key="seo-og-desc" property="og:description" content={meta_description} />,
        <meta key="seo-tw-desc" property="twitter:description" content={meta_description} />
      );
    }
  
    const image = fm.meta_image || "/logo.png";
    metaTags.push(
      <meta key="seo-og-img" property="og:image" content={image} />,
      <meta key="seo-tw-img" property="twitter:image" content={image} />
    );
  
    return metaTags;
  }
  